import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function users() {
    return {
        index,
        create,
        update,
        getUserDetail,
        deleteUser,
        addPhoto,
        changePassword,
        deleteImage
    };
}
function index(options = {}) {
    const defaultValues = {
        limit: 25,
        page: 1,
        pattern: '',
        active: true,
        type: null,
        agency: null
    };
    const params = generateQueryParams(options, defaultValues);
    return axiosInstance.get(`user/search${params}`);
}

function create(payload) {
    let data = new FormData();

    for (let key in payload) {
        const value = payload[key];
        if (key === 'roleIds') continue;
        if (value === undefined) {
            data.append(key, null);
        } else {
            if (key === 'image' && value) {
                data.append(key, value);
            } else {
                data.append(key, value);
            }
        }
    }

    if (Array.isArray(payload.roleIds)) {
        payload.roleIds.forEach((roleId) => {
            data.append('roleIds[]', roleId);
        });
    }

    const config = {
        method: 'post',
        url: 'user/create',
        headers: {
            'Content-Type': `multipart/form-data`
        },
        data: data
    };

    return axiosInstance(config)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.error(error);
            throw error.data;
        });
}

function update(payload) {
    let data = new FormData();
    for (let key in payload) {
        if (key === 'roleIds') continue;
        data.append(key, payload[key]);
    }

    const config = {
        method: 'post',
        url: 'user/update',
        headers: {
            'Content-Type': `multipart/form-data`
        },
        data: data
    };

    if (Array.isArray(payload.roleIds)) {
        payload.roleIds.forEach((roleId) => {
            data.append('roleIds[]', roleId);
        });
    }

    return axiosInstance(config)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.error(error);
            throw error.data;
        });
}

function getUserDetail(id) {
    return axiosInstance.get(`user/get?id=${id}`);
}

function deleteUser(payload) {
    return axiosInstance.delete(`user/delete`, {
        data: JSON.stringify(payload)
    });
}

function addPhoto(options, type = 'GALLERY') {
    const formData = new FormData();
    formData.append('id', options.id);
    formData.append('type', type);
    formData.append('file', options.photo);

    return axiosInstance.post('user/add-image', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

function deleteImage(payload) {
    return axiosInstance.delete(`user/delete-image`, {
        data: {
            id: payload.id
        }
    });
}

function changePassword(data) {
    return axiosInstance.post('user/update-password', data);
}
